import { api } from './client';
import type { TimelineEntry, CreateTimelineEntryRequest, UpdateTimelineEntryRequest } from '../features/timeline';
export type { TimelineEntry, CreateTimelineEntryRequest, UpdateTimelineEntryRequest } from '../features/timeline';

/** Public endpoint - get active timeline entries */
export async function getPublicTimeline(): Promise<TimelineEntry[]> {
  return api.get<TimelineEntry[]>('/api/timeline/public');
}

/** Admin endpoint - get all timeline entries */
export async function getTimeline(): Promise<TimelineEntry[]> {
  return api.get<TimelineEntry[]>('/api/timeline');
}

/** Get single timeline entry by ID */
export async function getTimelineEntry(id: string): Promise<TimelineEntry | null> {
  try {
    return await api.get<TimelineEntry>(`/api/timeline/${id}`);
  } catch {
    return null;
  }
}

/** Admin endpoint - create timeline entry */
export async function createTimelineEntry(data: CreateTimelineEntryRequest): Promise<TimelineEntry> {
  return api.post<TimelineEntry>('/api/timeline', data);
}

/** Admin endpoint - update timeline entry */
export async function updateTimelineEntry(
  id: string,
  data: UpdateTimelineEntryRequest
): Promise<TimelineEntry> {
  return api.patch<TimelineEntry>(`/api/timeline/${id}`, data);
}

/** Admin endpoint - delete timeline entry */
export async function deleteTimelineEntry(id: string): Promise<void> {
  return api.delete(`/api/timeline/${id}`);
}
